<template>
  <form v-on:submit.prevent="submitForm">

    <h2>Taxes</h2>
    <div class="form-group"><label for="id">ID :</label><input class="form-control" id="id" readonly="readonly" v-model="tax.id"/></div>
    <div class="form-group"><label for="taxJurisdictionID">Tax Jurisdiction ID : </label><input class="form-control" id="taxJurisdictionID" v-model="tax.taxJurisdictionID"/></div>
    <div class="form-group"><label for="taxJurisdictionCode">Tax Jurisdiction Code : </label><input class="form-control" id="taxJurisdictionCode" v-model="tax.taxJurisdictionCode"/></div>
    <div class="form-group"><label for="taxJurisdictionName">Tax Jurisdiction Name : </label><input class="form-control" id="taxJurisdictionName" v-model="tax.taxJurisdictionName"/></div>
    <div class="form-group"><label for="country">Country : </label><input class="form-control" id="country" v-model="tax.country"/></div>
    <div class="form-group"><label for="taxRuleID">Tax Rule ID : </label><input class="form-control" id="taxRuleID" v-model="tax.taxRuleID"/></div>
    <div class="form-group"><label for="taxGroupID">Tax Group ID : </label><input class="form-control" id="taxGroupID" v-model="tax.taxGroupID"/></div>
    <div class="form-group"><label for="taxRate">Tax Rate : </label><input class="form-control" id="taxRate" v-model="tax.taxRate"/></div>
    <div class="form-group"><label for="taxType">Tax Type : </label><input class="form-control" id="taxType" v-model="tax.taxType"/></div>
    <div class="form-group"><label for="taxSubType">Tax SubType : </label><input class="form-control" id="taxSubType" v-model="tax.taxSubType"/></div>
    <div class="form-group"><label for="taxName">Tax Name : </label><input class="form-control" id="taxName" v-model="tax.taxName"/></div>
    <div class="form-group"><label for="effectiveDate">Effective Date : </label><input class="form-control" id="effectiveDate" v-model="tax.effectiveDate"/></div>
    <div class="form-group"><label for="expirationDate">Expiration Date : </label><input class="form-control" id="expirationDate" v-model="tax.expirationDate"/></div>
    <div>
      <p>
        <input class="btn btn-edit" type="submit" value="Submit">
      </p>

      <p class="btn btn-deprecate" @click="deprecateTax()">
        <v-icon> mdi-clock </v-icon>
        <input class="btn" value="Deprecate">
      </p>

      <p>
        <router-link class="btn btn-cancel" v-bind:to="{path: 'taxes'}">
          <v-icon>mdi-cancel</v-icon>
          <input class="btn" type="submit" value="Cancel">
        </router-link>
      </p>
    </div>
  </form>
</template>

<script>
import {parameters} from "../../parameters";
import {httpClient} from "../../requesters/httpClient";

export default {
  name: 'EditTax',

  async created() {
    await httpClient.get(`${parameters.posdataRefUrl}/taxes/` + this.$route.query.id)
      .then((response)=> {
        this.tax = response.data;
      })
      .catch((error)=> {
        throw error;
      });
  },
  data() {
    return {
      tax : null
    }
  },
  methods: {
    async submitForm(e) {
      if (!this.areFieldsEmpty()) {
        await httpClient.post(`${parameters.posdataRefUrl}/overwrite/tax`, this.tax);

        await this.$alert("The tax was overwritten THEN updated");

        await this.$router.push('taxes');

        e.preventDefault();
      } else {
        await this.$alert("Some mandatory fields are empty")
      }
    },
    areFieldsEmpty: function() {
      if (this.tax.taxJurisdictionID === '' || this.tax.taxJurisdictionCode === ''
        || this.tax.taxJurisdictionCode === '' || this.tax.taxRuleID === '') {
        return true;
      }
    },
    async deprecateTax(){
      await httpClient.post(`${parameters.posdataRefUrl}/tax/` + this.tax.id + `/deprecate`)
        .then(function (response){
          if (response.status === 200){
            alert("The tax was deprecated")
          } else {
            alert("Tax is not present in database and can't be deprecated")
          }

        })
      await this.$router.push('taxes')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/taxes/EditTax.vue